import React from "react";


function TermsHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title">Terms</h2>
                </div>
            </div>
        </>
    );
}

export default TermsHeader;
